'use client';
import React, { useRef } from 'react';

export default function SocialColumn({ data }) {
  const content = useRef(null);

  const socialIcons = {
    facebook() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-facebook-icon"
          data-name="Layer-1"
          viewBox="0 0 7 16"
          className="h-4 w-4"
          role="img"
          aria-label="Facebook"
        >
          <title>Facebook</title>
          <g data-name="Layer 1">
            <path
              d="M7,0c-.003.047-.009.094-.009.139,0,.83,0,1.661.003,2.491,0,.099-.02.13-.118.13-.479,0-.957-.019-1.436.012-.111.007-.221.029-.328.066-.263.092-.387.305-.406.586-.04.578-.015,1.157-.026,1.737,0,.1.059.08.112.08h2.036c.027,0,.056.004.083,0,.078-.009.094.028.086.105-.088.859-.174,1.717-.256,2.577-.01.099-.066.076-.118.076-.606,0-1.213.003-1.819-.003-.102,0-.122.031-.122.135.003,2.571,0,5.144,0,7.715,0,.051-.003.104-.004.154H1.874l.003-.792c0-2.355,0-4.71.003-7.065,0-.116-.026-.147-.135-.146-.542.007-1.086,0-1.629.006-.098,0-.116-.031-.116-.128.004-.833.004-1.668,0-2.503,0-.099.023-.13.119-.129.547.004,1.093,0,1.64.003.097,0,.119-.03.119-.129.004-.749-.027-1.499.022-2.248.035-.537.127-1.063.362-1.549.256-.533.661-.882,1.183-1.083.265-.101.539-.155.816-.193.042-.006.097.013.127-.042h2.611Z"
              fillRule="evenodd"
              fill="#0e3739"
              className="group-hover:fill-[#aa6147]"
            />
          </g>
        </svg>
      );
    },
    twitter() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-x-icon"
          data-name="Layer 2"
          viewBox="0 0 16 14.465"
          role="img"
          aria-label="Twitter"
          className="h-4 w-4"
        >
          <title>Twitter</title>
          <g data-name="Layer 1">
            <path
              d="M12.603,0h2.455l-5.363,6.127,6.305,8.338h-4.94l-3.865-5.059-4.428,5.059H.319l5.734-6.557L0,0h5.066l3.494,4.621L12.603,0ZM11.742,12.996h1.358L4.325,1.395h-1.461l8.879,11.601Z"
              className="group-hover:fill-[#aa6147]"
            />
          </g>
        </svg>
      );
    },
    instagram() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          id="footer-instagram-icon"
          data-name="Layer 2"
          viewBox="0 0 16 16.001"
          role="img"
          aria-label="Instagram"
          className="h-4 w-4"
        >
          <title>Instagram</title>
          <defs>
            <mask
              data-name="mask"
              x="-4"
              y="-4"
              width="24"
              height="24"
              maskUnits="userSpaceOnUse"
            >
              <g data-name="mask0 0 2129">
                <rect x="-4" y="-4" width="24" height="24" fill="#ffff" />
              </g>
            </mask>
          </defs>
          <g data-name="Layer 1">
            <g mask="url(#d)">
              <g>
                <path
                  d="M8.001,0c-2.175,0-2.447.009-3.3.049-.851.039-1.432.174-1.94.372-.534.201-1.017.515-1.417.922-.407.4-.722.883-.923,1.417-.199.509-.334,1.091-.374,1.942-.037.854-.047,1.126-.047,3.298s.009,2.446.047,3.3c.039.85.175,1.433.374,1.942.204.525.476.971.922,1.416.445.446.89.718,1.417.924.509.196,1.09.333,1.943.371.852.039,1.125.049,3.298.049s2.445-.009,3.297-.049c.852-.038,1.433-.174,1.943-.371.534-.202,1.017-.517,1.416-.925.407-.399.722-.882.923-1.415.198-.509.333-1.091.374-1.943.037-.853.047-1.125.047-3.299s-.009-2.445-.047-3.298c-.04-.851-.176-1.433-.374-1.943-.201-.534-.516-1.017-.923-1.416-.4-.407-.883-.721-1.417-.922-.509-.198-1.09-.333-1.941-.372-.854-.039-1.127-.049-3.298-.049ZM8.001,1.441c2.135,0,2.39.008,3.232.047.78.036,1.205.166,1.486.276.374.146.639.318.919.598.28.28.454.547.599.921.109.28.24.705.275,1.485.038.844.047,1.096.047,3.232s-.009,2.389-.047,3.232c-.035.781-.166,1.204-.275,1.485-.128.348-.332.663-.598.922-.28.279-.547.453-.92.598-.282.109-.706.24-1.485.275-.844.037-1.098.047-3.232.047s-2.391-.009-3.234-.047c-.78-.035-1.204-.166-1.485-.275-.347-.128-.662-.333-.92-.598-.28-.28-.453-.547-.598-.921-.11-.282-.241-.705-.277-1.485-.037-.844-.046-1.096-.046-3.233s.007-2.389.047-3.232c.035-.78.165-1.205.275-1.485.146-.374.319-.641.599-.921.28-.28.546-.452.919-.598.282-.109.706-.239,1.486-.276.844-.038,1.097-.047,3.233-.047Z"
                  fillRule="evenodd"
                  fill="#0e3739"
                  className="group-hover:fill-[#aa6147]"
                />
                <path
                  d="M8.001,10.667c-1.472,0-2.667-1.192-2.667-2.665,0-1.472,1.192-2.667,2.665-2.667,1.472,0,2.667,1.193,2.667,2.665s-1.193,2.667-2.665,2.667M8,3.893c-2.269,0-4.108,1.839-4.108,4.108s1.839,4.108,4.108,4.108,4.108-1.839,4.108-4.108-1.839-4.108-4.108-4.108ZM13.23,3.73c0,.53-.43.96-.96.96s-.96-.43-.96-.96.43-.96.96-.96.96.43.96.96Z"
                  fillRule="evenodd"
                  fill="#0e3739"
                  className="group-hover:fill-[#aa6147]"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    },
    youtube() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-youtube-icon"
          data-name="Layer 2"
          viewBox="0 0 18 12.704"
          role="img"
          aria-label="YouTube"
          className="h-4 w-4"
        >
          <title>YouTube</title>
          <g data-name="Layer 1">
            <path
              d="M7.164,8.849V3.823l4.808,2.514-4.808,2.512ZM17.544,1.685c-.323-.82-.923-1.324-1.777-1.43-.932-.114-1.875-.151-2.815-.184C10.627-.009,8.3-.027,5.975.046c-1.176.033-2.352.088-3.526.167C1.352.291.643.912.315,1.963.11,2.621.038,3.301.025,3.979c-.032,1.571-.034,3.141-.004,4.712.014.688.086,1.38.295,2.049.232.743.647,1.319,1.408,1.55.414.127.855.213,1.287.232,2.022.087,6.071.182,6.071.182,1.056-.019,2.115-.02,3.169-.06,1.169-.045,2.341-.085,3.505-.205.864-.09,1.467-.607,1.79-1.435.225-.58.314-1.187.356-1.802.126-1.848.13-3.702.014-5.55-.041-.67-.122-1.334-.372-1.967Z"
              fillRule="evenodd"
              fill="#0e3739"
              className="group-hover:fill-[#aa6147]"
            />
          </g>
        </svg>
      );
    },
    pinterest() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-pinterest-icon"
          data-name="Layer 2"
          viewBox="0 0 12.386 16"
          className="h-4 w-4"
          role="img"
          aria-label="Pinterest"
        >
          <title>Pinterest</title>
          <g data-name="Layer 1">
            <path
              d="M7.427,11.564c-.992,0-1.925-.536-2.245-1.146,0,0-.533,2.118-.646,2.527-.398,1.444-1.568,2.888-1.66,3.007-.064.082-.203.056-.219-.053-.024-.184-.323-2.005.028-3.492l1.183-5.008s-.293-.585-.293-1.452c0-1.363.788-2.38,1.772-2.38.836,0,1.239.628,1.239,1.38,0,.841-.535,2.097-.812,3.261-.229.975.49,1.77,1.451,1.77,1.742,0,2.914-2.236,2.914-4.886,0-2.014-1.355-3.521-3.823-3.521C3.529,1.571,1.792,3.649,1.792,5.972c0,.801.236,1.366.607,1.802.17.201.193.281.132.512-.045.17-.146.577-.188.737-.06.234-.249.318-.459.23-1.284-.525-1.883-1.93-1.883-3.511C0,3.132,2.202,0,6.569,0c3.51,0,5.818,2.54,5.818,5.265,0,3.605-2.004,6.298-4.959,6.298Z"
              fillRule="evenodd"
              fill="#0e3739"
              className="group-hover:fill-[#aa6147]"
            />
          </g>
        </svg>
      );
    },
    tiktok() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-tiktok-icon"
          data-name="Layer 2"
          viewBox="0 0 13.851 16"
          className="h-4 w-4"
          role="img"
          aria-label="TikTok"
        >
          <title>TikTok</title>
          <g data-name="Layer 1">
            <path
              d="M12.125,3.419c-1.033-.454-1.967-1.881-2.034-2.75h.003c-.069-.407-.041-.67-.036-.67h-2.746v10.618c0,.171,0,.336-.01.504-.07,1.18-1.125,2.17-2.309,2.15-3.528-.142-2.696-5.506.713-4.55l.003-2.796c-5.164-.667-7.933,6.093-3.483,9.218v-.007c3.223,1.96,6.368.332,7.501-2.409.613-1.37.231-5.95.331-7.383.801.658,2.556,1.234,3.793,1.22v-2.726c-.338.037-1.024-.07-1.726-.42h0Z"
              fill="#0e3739"
              className="group-hover:fill-[#aa6147]"
            />
          </g>
        </svg>
      );
    },
    mailto() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-email-icon"
          data-name="Layer 2"
          viewBox="0 0 17 13"
          className="h-4 w-4"
          role="img"
          aria-label="Email"
        >
          <title>Email</title>
          <g data-name="Layer 1">
            <g data-name="Group">
              <path
                data-name="Vector"
                d="M1.389.5c-.491,0-.889.384-.889.857v10.286c0,.473.398.857.889.857h14.222c.491,0,.889-.384.889-.857V1.357c0-.473-.398-.857-.889-.857H1.389Z"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-[#0e3739] group-hover:stroke-[#aa6147]"
              />
              <path
                data-name="Vector 2"
                d="M.5,1.139l8.229,6.222,7.771-6.222"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="stroke-[#0e3739] group-hover:stroke-[#aa6147]"
              />
            </g>
          </g>
        </svg>
      );
    },
    sms() {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="footer-chat-icon"
          data-name="Layer 2"
          viewBox="0 0 17 17"
          className="h-4 w-4"
          role="img"
          aria-label="Text"
        >
          <title>Text</title>
          <g data-name="Layer 1">
            <path
              data-name="Vector"
              d="M8.5,16.5c-1.574,0-3.042-.455-4.28-1.24l-3.72,1.24,1.24-3.72c-.785-1.238-1.24-2.706-1.24-4.28C.5,4.082,4.082.5,8.5.5s8,3.582,8,8-3.582,8-8,8Z"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="stroke-[#0e3739] group-hover:stroke-[#aa6147]"
            />
          </g>
        </svg>
      );
    }
  };

  function SocialIcon({ url }) {
    const socialKey = Object.keys(socialIcons).find((key) => url.includes(key));
    return socialIcons[socialKey]() || '';
  }

  return (
    <div className="focus:outline-none" tabIndex="0">
      <div className="sh12 sm:sh11 mb-4 sm:mb-5">
        <div>
          <a href="sms:+17573948174" className="sm:hidden">
            {data.title}
          </a>
          <span
            className="sh11 hidden sm:inline-block"
            role="heading"
            aria-level="2"
          >
            {data.title}
          </span>
        </div>
      </div>
      <div ref={content} className="max-h-screen overflow-hidden sm:max-h-96">
        <div>
          <ul className="flex flex-row items-center">
            {data.social_list.map((item, index) => {
              if (item.social_link.href) {
                return (
                  <li
                    key={index}
                    className={`${item.social_link.title == 'Text' ? 'sm:hidden' : ''} justify-content relative flex h-8 w-8`}
                  >
                    <a
                      href={`${item.social_link.href}${item.query_string ?? ''}`}
                      className="group"
                      aria-label={`${item.social_link.title}, social link, opens in new window`}
                      data-social={item.social_link.title}
                      target="_blank"
                      rel="noopener noreferrer external"
                    >
                      <SocialIcon url={item.social_link.href} />
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
